import type React from 'react';
import { twMerge } from '@/lib/twMerge';
import CellData from './CellData';
import type { Feature, FeatureCells } from './types';

// Component for rendering a single feature row
const FeatureRow: React.FC<{
  categoryName: string;
  /** Plan columns to render, in display order — must match the header cells. */
  cellOrder: (keyof FeatureCells)[];
  feature: Feature;
}> = ({
  categoryName,
  cellOrder,
  feature
}) => {
  const {
    name,
    cells
  } = feature;
  return <tr className="border-0 border-gray-150 border-b border-solid dark:border-gray-800" key={`${categoryName}-${name}`} data-sentry-component="FeatureRow" data-sentry-source-file="FeatureRow.tsx">
      <td className={twMerge('px-4 py-2 text-base dark:text-white')}>{name}</td>
      {cellOrder.map(planKey => {
      const cell = cells[planKey];
      return <CellData checked={typeof cell === 'boolean' && cell} key={planKey} notApplicable={typeof cell === 'boolean' && !cell}>
            {typeof cell === 'boolean' ? undefined : cell}
          </CellData>;
    })}
    </tr>;
};
export default FeatureRow;